/**
 * Utility for window access when working with SSR
 */
export class Winda {
  static get window() {
    return typeof globalThis.window === "undefined" ? undefined : window;
  }

  static get isEmpty() {
    return typeof Winda.window === "undefined";
  }

  static get isPresent() {
    return !Winda.isEmpty;
  }

  static get<Key extends keyof Window>(key: Key): undefined | Window[Key] {
    return Winda.window ? window[key] : undefined;
  }

  static get isDataDogBot() {
    if (!Winda.isPresent) return false;

    return (
      window.navigator.userAgent.includes("DatadogSynthetics") ||
      (window as any)._DATADOG_SYNTHETICS_BROWSER === true
    );
  }
}
